import { gql } from "@apollo/client";

export default gql`
  fragment AccountOrganizationFragment on OrganizationNode {
    id
    name
    personal
    hasSlackConnection
    hasTeamsInstallation
    userMembership {
      id
      position
      phoneNumber
      phoneNumberVerified
      phoneNumberVerifiedAt
    }
    directorySync {
      id
      state
      type
      name
    }
    members {
      edges {
        node {
          id
          user {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;
